import moment from 'moment';

export const getDate = dateString => {
	return moment(dateString).format('DD MMMM YYYY');
};

export const getTime = dateString => {
	return moment(dateString).format('LT');
};
